"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        class ColorPaletteEditor extends distill.EditorBase {
            init() {
                this.$presetSelect = this.$editor.find('.palette-preset-select');
                this.$customContainer = this.$editor.find('.custom-colors-container');
                this.$customGrid = this.$editor.find('.custom-colors-grid');
                if (this.propDef.path && this.propDef.path.includes('.'))
                    this.parentPath = this.propDef.path.substring(0, this.propDef.path.lastIndexOf('.'));
                else
                    this.parentPath = 'styling';
                Object.keys(dashboards.DashColorPalettes).forEach(key => {
                    this.$presetSelect.append($('<option>').val(key).text(key));
                });
                this.$presetSelect.append($('<option>').val('Custom').text('Custom'));
            }
            render() {
                super.render();
                appn.select.initForDesign({ elements: this.$presetSelect });
            }
            update() {
                const preset = this.getValue();
                this.$presetSelect.val(preset).trigger('change.select2');
                if (preset === 'Custom') {
                    this.$customContainer.showElement();
                    this.renderCustomPickers();
                }
                else {
                    this.$customContainer.hideElement();
                }
            }
            getCustomColors() {
                const parentObj = appn.designerv2.getPropertyByPath(this.component, this.parentPath) || {};
                return parentObj['customColorPalette'] || [];
            }
            saveCustomColors(newColors) {
                const parentObj = appn.designerv2.getPropertyByPath(this.component, this.parentPath) || {};
                const updatedParent = Object.assign({}, parentObj);
                updatedParent['customColorPalette'] = newColors;
                dashboards.designer.updateComponentProperty(this.component.id, this.parentPath, updatedParent);
            }
            renderCustomPickers() {
                this.$customGrid.empty();
                let customColors = this.getCustomColors();
                customColors = [...customColors];
                while (customColors.length < 12)
                    customColors.push('#ffffff');
                customColors = customColors.slice(0, 12);
                customColors.forEach((color) => {
                    const $picker = $('<input type="text" class="custom-color-picker form-control form-control-sm"/>');
                    this.$customGrid.append($picker);
                    $picker.minicolors(new appn.minicolors.Options());
                    $picker.minicolors('value', color);
                    $picker.on('change', () => {
                        if (this.$presetSelect.val() !== 'Custom')
                            return;
                        const newColors = [];
                        this.$customGrid.find('.custom-color-picker').each(function () {
                            let val = $(this).val();
                            if (!val || val.trim() === '' || val.trim() === '#')
                                val = '#ffffff';
                            newColors.push(val);
                        });
                        this.saveCustomColors(newColors);
                    });
                });
            }
            bindEvents() {
                this.$presetSelect.on('change', (e) => {
                    const selectedPreset = $(e.target).val();
                    if (selectedPreset === 'Custom') {
                        const currentColors = this.getCustomColors();
                        if (!currentColors || currentColors.length === 0) {
                            const defaultColors = dashboards.DashColorPalettes['Vibrant'] || [];
                            this.saveCustomColors([...defaultColors]);
                        }
                    }
                    this.setValue(selectedPreset);
                });
            }
        }
        class LegendStyleEditor extends distill.EditorBase {
            init() {
                this.$vPos = this.$editor.find('.legend-vpos');
                this.$hPos = this.$editor.find('.legend-hpos');
            }
            render() {
                super.render();
                appn.select.initForDesign({ elements: this.$editor.find('select') });
            }
            update() {
                const style = this.getValue() || {};
                this.$vPos.val(style.verticalPosition || 'bottom').trigger('change.select2');
                this.$hPos.val(style.horizontalPosition || 'center').trigger('change.select2');
            }
            bindEvents() {
                this.$editor.on('change', 'select', () => {
                    const vPos = this.$vPos.val();
                    const hPos = this.$hPos.val();
                    const newStyle = {
                        verticalPosition: vPos,
                        horizontalPosition: hPos
                    };
                    this.setValue(newStyle);
                });
            }
        }
        dashboards.LegendStyleEditor = LegendStyleEditor;
        class ItemSelectorEditor extends distill.EditorBase {
            init() {
                this.$select = this.$editor.find('.item-selector');
                const itemList = dashboards.designer.getItemList();
                if (itemList && itemList.length > 0) {
                    itemList.forEach((folder) => {
                        const $option = $('<option>').val(folder.value).text(folder.text);
                        if (!folder.isArtifact)
                            $option.attr('data-is-doc', 'false');
                        this.$select.append($option);
                    });
                }
            }
            render() {
                super.render();
                appn.select.initForDesign({ elements: this.$select });
            }
            update() {
                if (this.$select.find('option').length === 0)
                    return;
                let value = this.getValue();
                if (!value)
                    value = [];
                else if (!Array.isArray(value))
                    value = [value];
                this.$select.val(value);
                this.$select.trigger('change.select2');
            }
            bindEvents() {
                this.$select.on('select2:select select2:unselect', (e) => {
                    const val = this.$select.val();
                    const valueToSave = val === null ? [] : val;
                    this.setValue(valueToSave);
                });
            }
        }
        dashboards.ItemSelectorEditor = ItemSelectorEditor;
        distill.editors.register('colorPalette', ColorPaletteEditor);
        distill.editors.register('legendStyle', LegendStyleEditor);
        distill.editors.register('itemSelector', ItemSelectorEditor);
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
